import hamburger from './HamburgerMenu.svg'
import twitter from './twitter.png'
import facebook from './facebook-app-symbol.png'
import instagram from './instagram.png'

const styles = {
  socialContainer: {
    flexDirection: 'column',
    display: 'flex',
    marginLeft: '25%',
    marginRight: '25%'
  },
  socialView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 20
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
  socialList: {
    flexDirection: 'row',
    marginTop: '15%'
  },
  socialIcon: {
    height: '100px',
    width: '100px',
    margin: 40
  }
}

function Social() {
  return (
    <div style={styles.socialContainer}>
      <div style={styles.socialView}>
        <a href='/menu'>
          <img src={hamburger} style={styles.menuIcon} />
        </a>
        <div style={styles.socialList}>
          <a href="https://twitter.com/pghDSA">
            <img src={twitter} style={styles.socialIcon} />
          </a>
          <a href="https://www.facebook.com/pghDSA">
            <img src={facebook} style={styles.socialIcon} />
          </a>
          <a href="https://www.instagram.com/pghdsa/">
            <img src={instagram} style={styles.socialIcon} />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Social;
